<template>
<div class="chapter">
<div class="inner_page">
<p><a id="als"></a></p>
<div class="fmhT">Also by Adam Clay</div>
<div class="ctag1"><i>The Wash</i> (Parlor Press, 2006)</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// adam_9781571318602_oeb_als_r1.vue?125bf749